import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService, ConfirmationService } from 'primeng/api';
import { SupervisorService } from 'src/app/services/supervisor.service';
import { Supervisor } from 'src/app/models/supervisor.interface';
import { Enfermera } from 'src/app/models/enfermera.interface';
import { AuthService } from 'src/app/services/auth.service';
import { HttpErrorResponse } from '@angular/common/http';
import { forkJoin } from 'rxjs';
import { CasoClinico } from 'src/app/models/caso-clinico.interface';
@Component({
  selector: 'app-supervisor-enfermeras',
  templateUrl: './supervisor-enfermeras.component.html',
  styleUrls: ['./supervisor-enfermeras.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class SupervisorEnfermerasComponent {
  supervisor!: Supervisor;
  catalogoEnfermeras: Enfermera[] = [];
  enfermeraForm!: FormGroup;

  get enfermeras(): Enfermera[] {
    return this.supervisor.enfermeras;
  }
  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private supervisorService: SupervisorService,
    private authService: AuthService) {

    if (this.authService.isLoggedIn) {
      const id: number | undefined = this.authService.getUsuario?.supervisor?.id;
      this.enfermeraForm = this.crearFormulario();
      if (id) this.obtenerInformacion(id);
    }

  }

  onSubmit(): void {
    this.agregarEnfermera();
  }
  crearFormulario(): FormGroup {
    return this.fb.group({
      enfermera: ['', Validators.required]
    });
  }
  obtenerInformacion(id: number): void {
    this.cargarDatos(id);
  }

  cargarDatos(id: number): void {
    forkJoin({
      subSupervisor: this.supervisorService.getSupervisor(id),
      subCatalogo: this.supervisorService.getCatalogoEnfermeras(id),
    }).subscribe({
      next: (resp) => {
        this.fullSupervisor(resp.subSupervisor.datos);
        this.fullCatalogo(resp.subCatalogo.datos);
      },
      error: (err) => { console.log(err) }
    });
  }

  fullSupervisor(supervisor: Supervisor): void {
    this.supervisor = supervisor;
  }

  fullCatalogo(enfermeras: Enfermera[]): void {
    this.catalogoEnfermeras.push(...enfermeras);
  }

  eliminarEnfermera(id: number) {
    this.confirmationService.confirm({
      message: 'Estas seguro de quitar al enfermera?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {

        this.supervisorService.desasociarEnfermera(id)
          .subscribe({
            next: (resp) => {
              const enfermera: Enfermera = resp.datos
              this.supervisor.enfermeras = this.supervisor.enfermeras.filter((item) => item.id != enfermera.id);

              this.showSuccess('Desasignacion exitosa');
            },
            error: (err: HttpErrorResponse) => { this.showError(err.error.message); console.log(err); }
          })
      }
    });
  }
  agregarEnfermera(): void {
    const enfermera: Enfermera = <Enfermera>this.enfermeraForm.get('enfermera')?.value;
    if (this.authService.getUsuario?.supervisor?.id) {
      const fk_supervisor: number = this.authService.getUsuario?.supervisor?.id;
      this.supervisorService
        .asociarEnfermera(fk_supervisor, enfermera.id)
        .subscribe({
          next: (resp) => {
            let enfermera: Enfermera = resp.datos;
            this.supervisor.enfermeras.push(enfermera);
            this.resetForm();
            this.showSuccess(resp.mensaje);
          },
          error: (err: HttpErrorResponse) => { this.showError(err.error.message) }
        })

    }
  }
  showSuccess(mensaje: string): void {
    this.messageService.add({
      severity: 'success',
      summary: 'Éxito',
      detail: mensaje
    });
  }

  showError(mensaje: string): void {
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: mensaje
    });
  }

  resetForm(): void {
    this.enfermeraForm.reset();
  }

  puntos(casosclinicos: CasoClinico[]): number {
    const puntos = casosclinicos?.filter(item => item.status_canje === 0 || item.status_canje === 1).reduce((total, caso) => total + caso.e_puntos, 0);
    return puntos ? puntos : 0;
  }
}
